import { AnimatedSection } from "./AnimatedSection";
import { TextReveal } from "./TextReveal";
import { MockupCard } from "./MockupCard";

export function MockupsSection() {
  const mockups = [
    "/assets/imgs/case-studies/age_of_ai_3.png",
    "/assets/imgs/case-studies/age_of_ai_4.png",
    "/assets/imgs/case-studies/age_of_ai_5.png",
    "/assets/imgs/case-studies/age_of_ai_6.png",
    "/assets/imgs/case-studies/age_of_ai_7.png",
    "/assets/imgs/case-studies/age_of_ai_8.png",
    "/assets/imgs/case-studies/age_of_ai_9.png",
    "/assets/imgs/case-studies/age_of_ai_10.png",
  ];

  return (
    <AnimatedSection className="w-full px-4 sm:px-6 md:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <TextReveal>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-[#fd5b38] font-['Arial'] mb-2">
              High-Fidelity Mockups
            </h2>
          </TextReveal>
          <TextReveal delay={0.1}>
            <p className="text-[#6a7282] text-sm sm:text-base md:text-lg">
              Complete screen collection
            </p>
          </TextReveal>
        </div>

        {/* First row - 4 mockups */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 lg:gap-8 mb-3 sm:mb-4 md:mb-6 lg:mb-8">
          {mockups.slice(0, 4).map((url, idx) => (
            <MockupCard key={idx} imageUrl={url} delay={0.1 + idx * 0.1} />
          ))}
        </div>

        {/* Second row - 4 mockups */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4 md:gap-6 lg:gap-8">
          {mockups.slice(4, 8).map((url, idx) => (
            <MockupCard key={idx} imageUrl={url} delay={0.1 + idx * 0.1} />
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
}
